import {Form} from '../../../stores/Form/Form';

export const findFormByLevel = (form: Form | null, activeLevel: number): Form | null => {
    if (form) {
        return form.level === activeLevel ? form : findFormByLevel(form.activeSubForm, activeLevel);
    }
    return null;
};
